import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-990aff84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "中奖名单", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "drawer_action_group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "drawer_list" }
const _hoisted_9 = { style: {"height":"calc(100vh - 200px)","overflow-y":"scroll"} }
const _hoisted_10 = { class: "drawer_footer" }
const _hoisted_11 = { class: "btn_group" }

import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { computed, reactive, ref, unref } from 'vue';
import { Button, message, notification, Table } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { WinType } from './lottery';
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'WinningList',
  props: {
    dataDraw: null
  },
  emits: ['click:callbackWinPage'],
  setup(__props: any, { emit }) {

const prpos = __props as { dataDraw: any };

const aButton = Button;
const aTable = Table;
const studioId = router.currentRoute.value.params.studioId;

const onBlack = () => {
  emit('click:callbackWinPage');
};

// 获取普通抽奖中奖名单
const winList = ref<WinType[]>([]);
const lastPage = ref(); //最后一页数据
const loadpageSize = ref(1); // 第几页数据
const noMore = ref(false); //判断是否有更多数据
const getWinList = (current: number) => {
  const data = {
    studio_id: studioId,
    page: current,
    page_num: 15,
    draw_no: prpos.dataDraw.draw_no,
  };
  http.lottery.getWinList({ params: data }).then((res) => {
    lastPage.value = res.data.data.last_page;
    winList.value.push(...res.data.data.data);
  });
};
getWinList(1);
//滚动加载数据
const getChildList = () => {
  if (loadpageSize.value < lastPage.value) {
    noMore.value = false;
    loadpageSize.value++;
    getWinList(loadpageSize.value);
  } else {
    noMore.value = true;
  }
};
const columns = [
  {
    title: '奖项名称',
    dataIndex: 'title',
    align: 'left',
  },
  //   {
  //     title: '奖品名称',
  //     dataIndex: 'mobile',
  //     align: 'center',
  //   },
  {
    title: '观众名称',
    dataIndex: 'realname',
    align: 'center',
  },
  {
    title: '观众信息',
    dataIndex: 'mobile',
    align: 'center',
  },
];

const selectedRowKeys = ref<string[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: string[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};

// 抽奖 名单管理 导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const drawExport = useDebounce((type: number) => {
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
    draw_no: prpos.dataDraw.draw_no,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
  // 1全部 2观看量排名 3设备占比 4观看途径 5访问来源 6榜单排行 7观看流水 8群聊记录 9私聊记录 10邀约码
  // 11直播间付费记录 12表单用户信息 13投票记录 14广告统计 15礼物打赏记录 16在线人数历史 17账单列表 18抽奖名单 19中奖名单
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aButton), {
          type: "link",
          class: "drawer_title_back",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回>>")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, "已中奖: " + _toDisplayString(winList.value.length) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createVNode(_unref(aTable), {
              columns: columns,
              "data-source": winList.value,
              pagination: false,
              rowKey: "id"
            }, null, 8, ["data-source"]), [
              [_directive_infinite_scroll, getChildList]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn",
            onClick: onBlack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn mod_type_primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(drawExport)(19)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      ok: openDelModal,
      close: openDelModal
    }, null, 8, ["visible"])
  ], 64))
}
}

})